export default __webpack_public_path__ + "static/media/Poppins-Regular.4211496d.ttf";